export default "__VITE_ASSET__CuJOwkJx__"